import React from "react"
import { connect } from "react-redux"
import { colors, responsive } from "buoy-theme"
import { Route } from "react-router-dom"
import styled from "styled-components"
import Header from "../../nav"
import * as actions from "../actions"

import ProfileDetails from "./ProfileDetails"
import DeleteAccountModal from "./DeleteAccountModal"
import ProfileSwitcher from "../../common/components/ProfileSwitcher"
import { getUserCharges } from "../../payment/actions"
import Cards from "../../common/components/ProfileCards"

import { Modal, LoadingSpinner } from "buoy-core"
import { pushRoute } from "../../common/route"
import VisitCard from "./VisitCard"
import AccountSettingsCard from "./AccountSettingsCard"

const OuterContainer = styled.div`
  display: flex;
  align-items: start;
  box-sizing: border-box;
  ${responsive(
    "padding",
    "210px 100px 20px",
    "210px 100px 20px",
    "210px 16px 20px",
    "210px 16px 20px",
    "210px 16px 20px"
  )};
  width: 100%;
  min-height: calc(100vh + 6px);
  justify-content: center;
  background-color: ${colors.neutralLightest};
`

const Profile = ({
  profiles,
  selectedProfile,
  select,
  deleteAccount,
  hideDeletionModal,
  deletionModalShown,
  hideHasSelfModal,
  hasSelfModalShown,
  match,
  loading,
  ...props
}) => (
  <React.Fragment>
    <Header />
    <OuterContainer>
      <ProfileSwitcher
        selectedProfile={selectedProfile}
        profiles={profiles}
        select={select}
      />
      <Cards>
        <Route
          path={`${match.path}/settings`}
          render={() => <AccountSettingsCard {...props} />}
        />
        <Route
          path={`${match.path}/visits`}
          render={() => <VisitCard {...props} />}
        />
        <Route
          exact
          path={`${match.path}`}
          render={() => (
            <ProfileDetails {...props} selectedProfile={selectedProfile} />
          )}
        />
      </Cards>
    </OuterContainer>
    {hasSelfModalShown && (
      <Modal
        heading="Looks like you still need a profile for yourself"
        message="Please fill out the form then select 'Save edits'"
        submitText="OK"
        submitEnabled={true}
        showCancel={false}
        submitClick={hideHasSelfModal}
        cancelClick={hideHasSelfModal}
      />
    )}
    {deletionModalShown && (
      <DeleteAccountModal
        closeModal={hideDeletionModal}
        deleteAccount={deleteAccount}
      />
    )}
    {(loading || props.predispositions.loading) && (
      <LoadingSpinner color="#196cff" overlay />
    )}
  </React.Fragment>
)

class ProfileContainer extends React.Component {
  state = {
    selected: 0,
    deletionModalShown: false,
    hasSelfModalShown: !this.props.hasSelf,
    profiles: this.props.hasSelf
      ? this.props.profiles
      : this.props.profiles.concat({
          name: "Me",
          id: "",
          isself: true,
          isfake: true,
        }),
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.loggedIn === "bad") {
      pushRoute("/login/")
    }

    if (prevProps.profiles !== this.props.profiles) {
      this.setState({ profiles: this.props.profiles })
    }

    // Add temporary self profile if none exists
    if (!this.props.hasSelf && this.props.hasSelf !== prevProps.hasSelf) {
      let new_profiles = this.props.profiles.concat({
        name: "Me",
        id: "",
        isself: true,
        isNew: true,
      })
      this.setState({
        profiles: new_profiles,
        hasSelfModalShown: !this.props.hasSelf,
      })
    }
  }

  select = selected => () => {
    this.props.setProfileError("")
    pushRoute("/profile/", true)
    this.setState({ selected })
  }

  hideHasSelfModal = () => {
    this.setState({ hasSelfModalShown: false })
    this.props.setProfileDirty(true)
  }

  showDeletionModal = () => {
    this.setState({ deletionModalShown: true })
  }
  hideDeletionModal = () => {
    this.setState({ deletionModalShown: false })
  }
  deleteAccount = reason => {
    this.props.deleteAccount(reason)
  }

  render() {
    // Put self profile first
    let profiles = this.state.profiles.sort((a, b) => {
      if (b.isself) return 1
      else if (a.isself) return -1
      else return a.name.localeCompare(b.name)
    })

    // Set default profile to self
    let selectedProfile = profiles[this.state.selected] || {}

    return (
      <Profile
        {...this.props}
        select={this.select}
        selectedProfile={selectedProfile}
        profiles={profiles}
        showDeletionModal={this.showDeletionModal}
        deletionModalShown={this.state.deletionModalShown}
        deleteAccount={this.deleteAccount}
        hideDeletionModal={this.hideDeletionModal}
        hasSelfModalShown={this.state.hasSelfModalShown}
        hideHasSelfModal={this.hideHasSelfModal}
      />
    )
  }
}

const mapStateToProps = state => ({
  loading: state.loading,
  visits: state.account.visits,
  email: state.auth.email,
  profiles: state.account.profiles,
  hasSelf: state.account.hasSelf,
  dirty: state.account.profileDirty,
  error: state.account.error,
  loggedIn: state.auth.status.login.status,
  predispositions: state.account.predispositions,
  planInformation: state.dashboard.planInformation,
  brand: state.brand.name,
})

const mapDispatchToProps = {
  getVisits: actions.getVisits,
  getResults: actions.getVisitResults,
  updateProfile: actions.updateProfile,
  setProfileDirty: actions.setProfileDirty,
  deleteAccount: actions.deleteAccount,
  getUserCharges: getUserCharges,
  setProfileError: actions.profileError,
  getProfileQuestions: actions.getProfileQuestions,
  setAnswer: actions.setPredispositionAnswer,
  saveProfileAnswers: actions.saveProfileAnswers,
  editPredispositions: actions.editPredispositions,
  cancelEditPredispositions: actions.cancelEditPredispositions,
}

const ProfileContainerWrapper = connect(mapStateToProps, mapDispatchToProps)(
  ProfileContainer
)

export { ProfileContainerWrapper as default, ProfileContainer, Cards }



// WEBPACK FOOTER //
// ./assets/account/components/Profile.js